import type { AssetMetadata } from '@/types/assetupload'
import { defineStore } from 'pinia'

interface userStore {
  isLoggedIn: boolean
  userDetails: any
  token: string | null
  otpDetails: any
  organisationId: string | null
  organisation: string | null
  allDeviceGroups: any
  allUsers: any
  isControllersModal: boolean
  enableDroneDefence: boolean
  droneDefenseSettings: {
    radius: number
    warningDistance: number
    criticalDistance: number
  }
  userAssets: AssetMetadata[]
  showUploadAssets: boolean
  selectedUploadType: string | ''
  selectLocationForAsset: boolean
  assetToEdit: AssetMetadata | null
  showEditAssetModal: boolean
  userAvatar: File | null
  userSub: string | undefined
}

export const useUserStore = defineStore('user', {
  state: (): userStore => ({
    isLoggedIn: false,
    userAssets: [],
    userDetails: null,
    userSub: undefined,
    token: null,
    otpDetails: null,
    organisationId: null,
    organisation: null,
    allDeviceGroups: [],
    allUsers: [],
    isControllersModal: false,
    enableDroneDefence: false,
    droneDefenseSettings: {
      radius: 20000,
      warningDistance: 1000,
      criticalDistance: 500,
    },
    showUploadAssets: false,
    selectedUploadType: '',
    selectLocationForAsset: false,
    assetToEdit: null,
    showEditAssetModal: false,
    userAvatar: null,
  }),
  getters: {
    userName(): string | null {
      if (!this.userDetails) return null
      return this.userDetails['cognito:username']
    },
    userId(): string | null {
      if (!this.userDetails) return null
      return this.userDetails.sub
    },
  },
  persist: {
    storage: sessionStorage,
  },
  actions: {
    saveUserDetails(payload: any) {
      this.userDetails = payload
    },
    saveOtpDetails(payload: any) {
      this.otpDetails = payload
    },
  },
})
